import styled from 'styled-components/macro';
import { Button } from 'ui-component-library';
import { FlexJustifyCenter } from '../../../../shared-styles/flex';

export const MainContainer = styled.div`
  ${({ isModal }) => (isModal ? 'width: 600px' : null)};
  padding: ${(props) => props.theme.spacing(15)} 0;
`;

export const TextLabel = styled.span`
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
`;

export const TextContainer = styled.div`
  margin-bottom: ${(props) => props.theme.spacing(20)};
  font-size: ${({ theme }) => theme.typography.sizes.small};
`;

export const SubmitButton = styled(Button)`
  margin-top: ${(props) => props.theme.spacing(20)};
  ${({ isModal }) => (isModal ? 'margin-left: auto' : null)};
`;

export const TextTitle = styled.div`
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
  margin-bottom: ${(props) => props.theme.spacing(20)};
`;

export const SpinnerContainer = styled.div`
  ${FlexJustifyCenter};
  height: 457px;
  width: 600px;
`;
